import React, { lazy } from 'react';
import { CONSTANTS } from '../utils/constants';
import { CountdownTimer } from './CountdownTimer';
import { PaymentBadges } from './PaymentBadges';
import { Check, ShieldCheck, ArrowRight, Download, Mail, Star } from 'lucide-react';
export const OfferSection: React.FC = () => {
  const handleBuyClick = () => {
    window.open(CONSTANTS.PAYMENT_LINK, '_blank');
  };
  return <section id="oferta" className="py-20 bg-gray-50 scroll-mt-20" data-id="element-150">
      <div className="max-w-5xl mx-auto px-4" data-id="element-151">
        <div className="text-center mb-12" data-id="element-152">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-153">
            Asegurá Tu Acceso Hoy Mismo
          </h2>
          <p className="text-xl text-gray-600 font-medium" data-id="element-154">
            Descarga inmediata. Pago 100% seguro.
          </p>
        </div>

        <div className="grid md:grid-cols-12 gap-8 items-start" data-id="element-155">
          {/* Left Column: Product Summary */}
          <div className="md:col-span-5 bg-white rounded-3xl p-6 shadow-sm border border-gray-200" data-id="element-156">
            <img src={CONSTANTS.PRODUCT_IMAGE} alt="Pack Completo" className="w-full h-auto drop-shadow-lg mb-6 rounded-xl" loading="lazy" data-id="element-157" />

            <h3 className="font-bold text-lg text-gray-900 mb-4 border-b pb-2" data-id="element-158">
              Resumen de tu pedido:
            </h3>

            <ul className="space-y-3" data-id="element-159">
              <li className="flex items-start space-x-3" data-id="element-160">
                <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-161" />
                <span className="text-gray-700 font-medium" data-id="element-162">
                  Ebook Principal Gimnasia Artística
                </span>
              </li>
              {['Plantilla Plan Anual Editable', 'Checklist de Seguridad', 'Guía Comunicación Padres', 'Selección Ejercicios Favoritos', 'Plantilla Evaluación Gimnasta'].map((bono, idx) => <li key={idx} className="flex items-start space-x-3" data-id="element-163">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-164" />
                  <span className="text-gray-600" data-id="element-165">{bono}</span>
                  <span className="ml-auto text-xs font-bold text-red-500 bg-red-50 px-2 py-0.5 rounded" data-id="element-166">
                    GRATIS
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Right Column: Pricing & Checkout */}
          <div className="md:col-span-7 bg-white rounded-3xl p-8 shadow-xl border-2 border-green-500 relative overflow-hidden" data-id="element-167">
            <div className="absolute top-0 right-0 bg-green-500 text-white px-6 py-1.5 rounded-bl-2xl font-bold text-sm tracking-wider uppercase" data-id="element-168">
              Mejor Oferta
            </div>

            <div className="text-center mb-8 pt-4" data-id="element-169">
              <div className="inline-flex items-center justify-center space-x-2 bg-red-50 text-red-600 px-4 py-2 rounded-full mb-6 border border-red-100" data-id="element-170">
                <span className="font-bold text-sm uppercase" data-id="element-171">Termina en:</span>
                <CountdownTimer size="sm" theme="light" data-id="element-172" />
              </div>

              <div className="flex items-center justify-center space-x-4 mb-2" data-id="element-173">
                <span className="text-2xl text-gray-400 line-through font-bold" data-id="element-174">
                  {CONSTANTS.PRICES.ORIGINAL}
                </span>
                <span className="bg-green-100 text-green-800 text-sm font-bold px-3 py-1 rounded-full" data-id="element-175">
                  Ahorrás {CONSTANTS.PRICES.SAVINGS}
                </span>
              </div>

              <div className="text-6xl md:text-7xl font-black text-gray-900 tracking-tighter mb-2" data-id="element-176">
                {CONSTANTS.PRICES.SALE}
              </div>
              <p className="text-gray-500 font-medium" data-id="element-177">
                Pesos Argentinos (ARS) - Pago Único
              </p>
            </div>

            <button onClick={handleBuyClick} className="w-full bg-green-500 hover:bg-green-600 text-white font-black text-2xl py-5 px-8 rounded-2xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200 flex flex-col items-center justify-center mb-6" data-id="element-178">
              <span className="flex items-center" data-id="element-179">
                COMPRAR AHORA <ArrowRight className="ml-2 w-6 h-6" data-id="element-180" />
              </span>
              <span className="text-sm font-medium text-green-100 mt-1" data-id="element-181">
                Acceso inmediato al material
              </span>
            </button>

            <PaymentBadges data-id="element-182" />

            <div className="mt-8 bg-green-50 rounded-xl p-4 border border-green-100 flex flex-wrap justify-center gap-4 text-sm font-bold text-green-800" data-id="element-183">
              <div className="flex items-center" data-id="element-184">
                <ShieldCheck className="w-4 h-4 mr-1" data-id="element-185" /> Transacción Segura 100%
              </div>
              <div className="flex items-center" data-id="element-186">
                <Star className="w-4 h-4 mr-1" data-id="element-187" /> Garantía 45 Días
              </div>
              <div className="flex items-center" data-id="element-188">
                <Check className="w-4 h-4 mr-1" data-id="element-189" /> Pago Único
              </div>
            </div>
          </div>
        </div>

        {/* What happens next */}
        <div className="mt-16 max-w-4xl mx-auto" data-id="element-190">
          <h3 className="text-center text-2xl font-bold text-gray-900 mb-8" data-id="element-191">
            ¿Qué pasa después de comprar?
          </h3>
          <div className="grid md:grid-cols-3 gap-6" data-id="element-192">
            <div className="bg-white p-6 rounded-2xl border border-gray-200 text-center" data-id="element-193">
              <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-194">
                <span className="font-black text-xl" data-id="element-195">1</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-196">Pago Seguro</h4>
              <p className="text-sm text-gray-600" data-id="element-197">
                Completás tu pago de forma 100% segura a través de nuestra
                plataforma.
              </p>
            </div>
            <div className="bg-white p-6 rounded-2xl border border-gray-200 text-center" data-id="element-198">
              <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-199">
                <Mail className="w-6 h-6" data-id="element-200" />
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-201">Email Inmediato</h4>
              <p className="text-sm text-gray-600" data-id="element-202">
                Recibís un correo electrónico al instante con tus datos de
                acceso.
              </p>
            </div>
            <div className="bg-white p-6 rounded-2xl border border-gray-200 text-center" data-id="element-203">
              <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-204">
                <Download className="w-6 h-6" data-id="element-205" />
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-206">Descarga Total</h4>
              <p className="text-sm text-gray-600" data-id="element-207">
                Descargás el ebook y los 5 bonos a tu computadora o celular para
                siempre.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};